import isDemo from '@/lib/utils/is_demo';
import { httpPut } from '../rest';

export function updatePaymentInfo(httpPut, isDemo) {
  return {
    async execute({ transitNumber, institutionNumber, accountNumber }) {
      const params = {
        transit_number: transitNumber,
        institution_number: institutionNumber,
        account_number: accountNumber,
      };

      return performUpdate(params);
    },
  };

  async function performUpdate(params) {
    if (isDemo()) {
      return { success: true };
    }

    try {
      // EricW, 2021-01-05: We no longer use the advisor_payment_info table. The advisors#payment_info controller has been
      // swapped out with advisors#bank_accounts. All API requests for advisor banking information should be made to the
      // /bank_accounts endpoint.
      await httpPut('/bank_accounts', params);

      return { success: true };
    } catch (error) {
      if (error.response && error.response.status === 400) {
        return {
          success: false,
          responseData: error.response.data,
        };
      }

      throw error;
    }
  }
}

export default updatePaymentInfo(httpPut, isDemo);
